export default "__VITE_ASSET__Ba9HRK0$__"